import React from 'react';
import styles from './CardView.module.scss';
import classNames from 'classnames';

interface CardViewProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    className?: string;
    'data-testid'?: string;
}

export const CardView = ({ children, className = '', 'data-testid': testId, ...rest }: CardViewProps) => {
    return (
        <div className={classNames(styles.cardView, className)} data-testid={testId} {...rest}>
            {children}
        </div>
    );
};
